import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

import Antd, { message } from 'ant-design-vue' // antd-vue组件
import VueEasytable from 'vue-easytable' // 引入VueEasytable组件库
import Directives from './directive/index' // 全局注册指令
import TextOmission from '@/components/TextOmission' // 文本溢出组件
import PrivateNetwork from '@/components/PrivateNetwork' // 专网提示
import ExpandAndCollapse from '@/components/ExpandAndCollapse' // 展开收起
import BusinessCard from '@/components/BusinessCard' // 个人名片
import BaseTab from '@/components/BaseTab' // 基础tab
import BasePlan from '@/components/BasePlan' // 基础计划
import pagination from '@/components/pagination' // 分页

import '@/icons/index' // svg全局注册
import '@/utils/rem' // rem适配
import '@/utils/jsBridge.js' // 引入原生交互jsBridge
import '@/utils/viewportWidth' // 动态获取屏幕宽度

import 'ant-design-vue/dist/antd.css' // antd-vue样式库
import 'vue-easytable/libs/theme-default/index.css' // 引入VueEasytable样式库
import '@/assets/iconfont/iconfont.css' // 字体图标样式库
import '@/assets/css/base.scss' // 公共样式库base
import '@/assets/css/index.scss' // 公共样式库index

import { RecycleScroller, DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

// 事件总线
const bus = new Vue()
Vue.prototype.$bus = bus

//注入全局属性$message
Vue.prototype.$message = message
message.config({
  top: `60px`, // 到页面顶部距离
  maxCount: 1, // 最大显示数
  duration: 2 // 持续时间
})

// 挂载全局loading方法
Vue.prototype.$setLoading = function (props) {
  if (typeof props === 'boolean') props = { spinning: props }
  if (Object.prototype.toString.call(props) !== '[object Object]') props = {}
  this.$app.loadingProps = {
    tip: '',
    ...props
  }
}

Vue.use(Antd)
Vue.use(Directives)
Vue.use(VueEasytable)

Vue.component('TextOmission', TextOmission) // 注册TextOmission组件为全局组件
Vue.component('PrivateNetwork', PrivateNetwork) // 注册专网提示组件
Vue.component('ExpandAndCollapse', ExpandAndCollapse) // 注册展开收起
Vue.component('BusinessCard', BusinessCard) // 注册名片
Vue.component('BaseTab', BaseTab)
Vue.component('BasePlan', BasePlan)
Vue.component('pagination', pagination)

Vue.component('RecycleScroller', RecycleScroller)
Vue.component('DynamicScroller', DynamicScroller)
Vue.component('DynamicScrollerItem', DynamicScrollerItem)

new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js